import { Controller } from "@hotwired/stimulus"
import { put } from '@rails/request.js'

// Connects to data-controller="auto-save-form"
export default class extends Controller {
  VALID_ELEMENTS = ['INPUT', 'SELECT', 'TEXTAREA']

  connect() {
    this.registerFields()
  }

  registerFields(){
    const elements = this.element.elements
    for (let element of elements) {
      if (element.type === 'hidden' || !this.VALID_ELEMENTS.includes(element.tagName)){
        continue
      }

      element.addEventListener('blur', (e) => {
        this.saveForm(e)
      })
    }
  }

  async saveForm(e){
    const formData = new FormData(this.element)

    await put(this.element.action, {
      body: formData,
      responseKind: 'json',
    })
  }
}
